import axios from "axios";

/** Default config for axios instance */
let config = {
  baseURL: "https://florist.tory.ae/api/public/",
  headers: {
    Authorization: {
      toString() {
        return localStorage.getItem("token");
      },
    },
  },
};

export const getUrl = (method) =>
  `https://florist.tory.ae/api/public/?a=${method}`;

/** Creating the instance for axios */
export const HTTP = axios.create(config);
